---
meta:
title: About us
description: The Swiss Esports Hub is a project created by the Swiss Esports Federation to have a overview of the local esports scene.
links: none
---


import ContentPageLayout from "../../components/ContentPageLayout";

# About us
The Swiss Esports Hub is a project created by the Swiss Esports Federation (SESF) to have an overview of the local esports scene.
Development was started by students from the Zürcher Hochschule für Angewandte Wissenschaften (ZHAW). Further development was done
by a team consisting of some of the students as well as some web developers from the Swiss esports scene.

## Team
**Tobias Zischler** - Project Lead, Developer

**Mika Ruch** - Software Architect, Developer

**Stephan Giumelli** - DevOps, Developer

**Yann Beaud** - Product Owner


## Honorable Mentions
Mathias Fischler - Developer

Cagatay Özyurt - Developer

Jorge Paravinicini - Developer

export default ({ children }) => <ContentPageLayout>{children}</ContentPageLayout>;
